module.exports = __webpack_public_path__ + "fonts/WorkSans-Regular.5c606ec.woff2";